import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import {Observable} from 'rxjs';
import {UserService} from "../service/user.service";
import  Parse from 'parse';

@Injectable({
    providedIn: 'root'
})
export class IsLoggedGuard  {
    constructor(private router: Router,
                private userService: UserService) {
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (this.userService.isLogged()) {
            return this.router.parseUrl(this.userService.urlRedirection);
        } else {
            return true;
        }
    }

}
